import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LiderSzczegolowoPage } from "@/features/sys-premiowy/lider-szczegolowo-page";
import { ensureElementVisible } from "@/lib/route-guards";

// Konkurs, sortowanie i filtry w URL-u — raport wysyla sie linkiem.
const searchSchema = z.object({
	listId: z.coerce.number().int().optional(),
	sortBy: z.string().optional(),
	sortDir: z.enum(["asc", "desc"]).optional(),
	columnFilters: z.string().optional(),
	// Porownanie z wyplatami (tylko z elementem wyplat): niewyplacone / nadplacone.
	tryb: z.enum(["wszystkie", "niewyplacone", "nadplacone"]).optional().catch(undefined),
	// Grupowanie po stronie serwera: wymiary po przecinku (np. "apteka,kasjer").
	groupBy: z.string().optional(),
});

export type LiderSzczegolowoSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/system-premiowy/lider-szczegolowo")({
	component: LiderSzczegolowoPage,
	validateSearch: (search: Record<string, unknown>): LiderSzczegolowoSearch =>
		searchSchema.parse(search),
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-lider-szczegolowo",
			location.pathname,
		);
	},
});
